export default "__VITE_ASSET__W0po3My2__"